
(function () {
  'use strict';

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.hksss-buy-now');
    if (!button || button.disabled) return;

    const component = button.closest('product-form-component');
    const form = component?.querySelector(
      'form[data-type="add-to-cart-form"]'
    );

    if (!form) {
      alert('Product form not found. Please refresh and try again.');
      return;
    }

    const variant = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');

    if (!variant?.value) {
      alert('Please select an available product variant.');
      return;
    }

    const quantity = Math.max(
      1,
      parseInt(quantityInput?.value || '1', 10) || 1
    );

    const originalText = button.textContent;
    const error = component.querySelector('.hksss-buy-now-error');

    button.disabled = true;
    button.textContent = button.dataset.loadingText || 'Processing...';
    if (error) error.textContent = '';

    try {
      // Preserve the existing cart and add the selected variant.
      const data = new FormData(form);
      data.set('id', variant.value);
      data.set('quantity', String(quantity));

      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/add.js',
        {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      );

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(
          result.description || result.message ||
          'Unable to add this item. Please check availability.'
        );
      }

      // Open Shopify's standard checkout directly.
      window.location.assign(
        (window.Shopify?.routes?.root || '/') + 'checkout'
      );
    } catch (err) {
      if (error) {
        error.textContent = err.message || 'Something went wrong. Please try again.';
      } else {
        alert(err.message || 'Unable to proceed to checkout.');
      }

      button.disabled = false;
      button.textContent = originalText;
    }
  });
})();
